import {HoverButtonNative} from "./components/Button/Button";

const initPseudoLinks = () => {
  const links = document.querySelectorAll('.dl-pseudo-link');
  links.forEach(link => {
    const href = link.getAttribute('data-href');
    if (!href) {
      console.warn('pseudo-link without data-href attribute', link);
      return;
    }
    link.addEventListener('click', () => {
      window.location.href = href;
    });
  })
}

const initHoverButtons = () => {
  const hoverButtons = document.querySelectorAll('.dl-hover-button');
  hoverButtons.forEach(button => {
    const span = button.querySelector('span');
    if (!span) {
      console.warn('dl-hover-button must have span element inside, ignoring', button);
      return;
    }
    button.addEventListener('mouseenter', HoverButtonNative(button, span));
    button.addEventListener('mouseleave', HoverButtonNative(button, span));
  })
}

// call all functions here
initPseudoLinks();
initHoverButtons();

// default export
export {};
